import React from "react";
import { createBrowserRouter } from "react-router-dom";

import Root from "../react-routes/root";
import { Vendors, Vendor } from "../components/Vendor";
import Transaction, {
  loader as transactionLoader
} from "../components/Transaction";
import Proposals from "../components/Proposals";
import { Welcome } from "../components/Welcome";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { Carbonizer } from "../components/Carbonizer/Carbonizer";
import { PageLayout } from "components/Page";
import { ImageUploader } from "components/ImageUploader";
import { ContentSearch } from "../components/Content/ContentSearch";
import { Content } from "../components/Content/Content";
import { Genie } from "../components/Genie";
import ProductTypes from "../components/Genie/ProductTypes";
import { Poll, PollsList } from "../components/Polls";
import {
  CollectiveChallenge,
  CollectiveChallengesList
} from "../components/CollectiveChallenges";
import { IngredientChecker } from "../components/Genie/IngredientChecker";
import CSVUploaders from "components/CSVUploaders";
import BrandVendorGrid from "components/Vendor/BrandVendor/BrandVendorGrid";
import { BrandAttributeEditor } from "components/BrandAttributes";
import BrandDetail from "components/Brands/BrandDetail";
import BrandCreate from "components/Brands/BrandCreate";
import BrandScrapedPage from "components/Brands/BrandScrapedPage";
import BrandRatingDetail from "components/Brands/BrandRatingDetail";
import BrandRatingRubricsPage from "components/BrandRating/BrandRatingRubricsPage";
import BrandRatingRubricPage from "components/BrandRating/BrandRatingRubricPage";
import { IngredientGlossaryEditor } from "components/IngredientGlossary";
import GenieCollections from "../components/Genie/GenieCollections";
import CommunityReviewPage from "../components/CommunityReview";
import { CommunityReviewDetails } from "../components/CommunityReview/Details";
import CanonicalAggregationsPage from "../components/CanonicalAggregations";
import VendorRevendorizationPage from "../components/VendorRevendorization";
import ProductsPage from "../components/Products";
import VendorMemoTester from "components/Vendor/MemoTester";
import Transactions from "components/Vendor/Transactions";
import VendorCorrectedVendors from "components/Vendor/CorrectedVendors";
import BullMQMonitor from "components/BullMQMonitor";
import SpendingGoals from "components/SpendingGoals";
import { FeatureFlagsEditor } from "components/FeatureFlags/FeatureFlagsEditor";
import SupportDashboard from "components/SupportDashboard";
import CarbonOffsetManagement from "components/carbonOffsetManagement";
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: "vendors",
        element: <Vendors />,
        children: [
          {
            path: ":id",
            element: <Vendor />
          },
          {
            path: ":id/memo-tester",
            element: <VendorMemoTester />
          },
          {
            path: ":id/corrected-vendors",
            element: <VendorCorrectedVendors />
          },
          {
            path: ":id/transactions",
            element: <Transactions />
          }
        ]
      },
      {
        path: "brands/:id",
        element: <BrandDetail />
      },
      {
        path: "brands/:id/scraped-pages/:pageId",
        element: <BrandScrapedPage />
      },
      {
        path: "brands/:id/ratings/:ratingId",
        element: <BrandRatingDetail />
      },
      {
        path: "brands/new",
        element: <BrandCreate />
      },
      {
        path: "brands",
        element: <BrandVendorGrid />,
        children: [
          {
            path: ":id",
            element: <BrandVendorGrid />
          }
        ]
      },
      {
        path: "brandAttributes",
        element: <BrandAttributeEditor />,
        children: [
          {
            path: ":id",
            element: <BrandAttributeEditor />
          }
        ]
      },
      {
        path: "brand-rating-rubrics",
        element: <BrandRatingRubricsPage />
      },
      {
        path: "brand-rating-rubrics/:id",
        element: <BrandRatingRubricPage />
      },
      {
        path: "articles",
        element: <ContentSearch />,
        children: [
          {
            path: ":id",
            element: <Content />
          }
        ]
      },
      {
        path: "new/transactions/:id/edit",
        element: <Transaction />,
        loader: transactionLoader
      },
      {
        path: "proposals",
        element: <Proposals />
      },
      {
        path: "genie",
        element: <Genie />
      },
      {
        path: "genie/producttypes",
        element: <ProductTypes />
      },
      {
        path: "genie/collections",
        element: <GenieCollections />,
        children: [
          {
            path: ":collectionId",
            element: <GenieCollections />
          }
        ]
      },
      {
        path: "polls",
        element: <PollsList />,
        children: [
          {
            path: ":pollId",
            element: <Poll />
          }
        ]
      },
      {
        path: "collectivechallenges",
        element: <CollectiveChallengesList />,
        children: [
          {
            path: ":challengeKey",
            element: <CollectiveChallenge />
          }
        ]
      },
      {
        path: "uploaders",
        element: <CSVUploaders />
      },
      {
        path: "ingredientGlossary",
        element: <IngredientGlossaryEditor />
      },
      {
        path: "carbon",
        element: <Carbonizer />
      },
      {
        path: "carbon_offset_management",
        element: <CarbonOffsetManagement />
      },
      {
        path: "images",
        element: <ImageUploader />
      },
      {
        path: "checker",
        element: <IngredientChecker />
      },
      {
        path: "community-reviews",
        children: [
          {
            index: true,
            element: <CommunityReviewPage />
          },
          {
            path: ":id",
            element: <CommunityReviewDetails />
          }
        ]
      },
      {
        path: "canonical-aggregations",
        element: <CanonicalAggregationsPage />
      },
      {
        path: "vendor-revendorizations",
        element: <VendorRevendorizationPage />
      },
      {
        path: "products",
        element: <ProductsPage />
      },
      {
        path: "job-monitor",
        element: <BullMQMonitor />
      },
      {
        path: "spendingGoals",
        element: <SpendingGoals />
      },
      {
        index: true,
        element: <Welcome />
      },
      {
        path: "feature-flags",
        element: <FeatureFlagsEditor />
      },
      {
        path: "support",
        element: <SupportDashboard />
      },
      {
        path: "support/:userId",
        element: <SupportDashboard />
      },
      {
        path: "*",
        element: (
          <PageLayout>
            <h1>404 not found</h1>
          </PageLayout>
        )
      }
    ]
  }
]);
